export default "__VITE_ASSET__CdOAITtI__"